import { QueryKey } from 'react-query';
import { ID } from 'services/requests';

export function findUserInTableItems<U extends { id: number }, T extends { items: U[] }>(
  cachedQueries: [QueryKey, T][],
  id: ID,
): U | undefined {
  for (const [, queryData] of cachedQueries) {
    const foundUser = queryData?.items?.find((d) => d.id === Number(id));

    if (foundUser) {
      return foundUser;
    }
  }

  return undefined;
}
